import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as Form from "@radix-ui/react-form";
import { toast } from "react-toastify";
import styled from "styled-components";
import useAuth from "../hooks/useAuth";
import axios from "../../api/axios";
import Logo from "../Logo";
import {
  Button,
  Content,
  Loader,
  SectionWrapper,
  SpinnerIcon,
} from "../Styles";
import EmailInput from "./EmailInput";
import PasswordInput from "./PasswordInput";
import CustomLabel from "../CustomLabel";
import Header from "../reuse/Header";
import backgroundImage from "../../hhs-building-front-final.jpg";

const NavigationButtons = styled.div`
  /* display: flex;
  justify-content: space-between; */
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
`;

const ContentWrapper = styled.div`
  flex: 1;
  /* overflow-y: auto; */
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* background-attachment: fixed; */

  /* padding-top: 60px;
  padding-bottom: 40px; */

  /* @media (max-width: 768px) {
    padding-top: 80px;
    padding-bottom: 60px;
  } */

  /* 
  @media (max-width: 480px) {
    padding-top: 350px;
    padding-bottom: 300px;
  } */
`;

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: "onChange",
  });

  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { auth, isAuthenticated, setAuth, setIsAuthenticated } = useAuth();
  // const [check, toggleCheck] = useToggle("isAuthenticated", false);

  const from = location.state?.from?.pathname || "/";

  const intl = useIntl();
  const emailMessage = "Email / Correo electrónico"; // intl.formatMessage(messages.email);
  const passwordMessage = "Password / Contraseña"; // intl.formatMessage(messages.password);

  // if the user is already authenticated, redirect an authenticated user to the landing page
  useEffect(() => {
    if (auth?.accessToken || isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [auth, isAuthenticated, from, navigate]);

  const onSubmit = async (values) => {
    setLoading(true);
    setIsSubmitted(true);

    try {
      const { email, password } = values;
      const response = await axios.post("/auth/login", {
        email,
        password: btoa(password),
      });

      setAuth(response.data);
      setIsAuthenticated(true);

      navigate(from, { replace: true });
    } catch (error) {
      let errMessage = "";
      if (!error?.response) {
        errMessage = "No Server Response | Sin respuesta del servidor";
      } else if (error.response?.status === 400) {
        errMessage =
          "Missing Email or Password | Falta el correo electrónico o la contraseña";
      } else if (error.response?.status === 401) {
        errMessage = "Unauthorized | No autorizado";
      } else {
        errMessage = "Login Failed | Error al iniciar sesión";
      }

      toast.error(errMessage);
    } finally {
      setLoading(false);
    }
  };

  if (auth?.accessToken || isAuthenticated) {
    return (
      <Loader>
        <SpinnerIcon size={60} />
      </Loader>
    );
  }

  return (
    <ContentWrapper>
      <Content>
        <SectionWrapper width="540px">
          <Logo />
          <Header
            text="SIGN IN / INICIAR SESIÓN"
            subtext1="Please use email and password created through the HHS registration link."
            subtext2="Por favor utilice el correo electrónico y la contraseña creada a través
      del enlace de registro del HHS."
          />

          <Form.Root onSubmit={handleSubmit(onSubmit)}>
            <EmailInput
              label={<CustomLabel label={emailMessage} required />}
              name="email"
              register={register}
              errors={isSubmitted && errors}
            />
            <PasswordInput
              label={<CustomLabel label={passwordMessage} required />}
              name="password"
              register={register}
              errors={isSubmitted && errors}
              showPassword={showPassword}
              setShowPassword={setShowPassword}
            />
            <Button type="submit" disabled={!isValid || !isDirty || loading}>
              {loading ? (
                <>
                  <SpinnerIcon /> Loading
                </>
              ) : (
                "sign in / iniciar sesión"
              )}
            </Button>

            <NavigationButtons>
              <div>
                <Link to="/forgot-password" style={{ marginRight: "auto" }}>
                  Forgot Password / Contraseña olvidada
                </Link>

                {/* <Link to="/register" style={{ marginLeft: "auto" }}>
              Register
            </Link> */}
              </div>
            </NavigationButtons>
          </Form.Root>
        </SectionWrapper>
      </Content>
    </ContentWrapper>
  );
}

export default Login;
